/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description React Hook useAssignableRoles
 */

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import QUERY_KEYS from 'app-constants/queryKeys';
import api from 'client/index';

/**
 * useAssignableRoles hook
 * @returns {UseQueryResult} useAssignableRoles
 */
const useAssignableRoles = (): UseQueryResult<UserManagement.IRoleResponse[], unknown> => {
	return useQuery({
		queryKey: [QUERY_KEYS.assignableRoles],
		queryFn: async () => {
			const { data } = await api.KeycloakUserApi.getAssignableRoles();
			return data as UserManagement.IRoleResponse[];
		},
		refetchOnMount: false,
	});
};

export default useAssignableRoles;
